/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-03 12:00:00
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Page, Button, Layout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { checkUserEnableShowAppVersionSwitching } from 'src/helpers/account-helper';

import Themes from './themes';
import { URL } from 'src/constants/links';
import YoutubeModal from 'src/components/views/common/youtube-modal';
import { TypeScreen } from './index';
import TitleHelp from 'src/components/views/common/title-help';

type Props = {
  installStatus: string,
  installAppStatus: string,
  themeSetupV2: boolean
};

type ComposedProps = Props & WithI18nProps;

type State = {
  youtubeModal: boolean
};

class ThemeSetupScreenList extends Component<ComposedProps, State> {
  state = {
    youtubeModal: false
  };

  handleOpenYoutubeModal = () => this.setState({ youtubeModal: true });
  handleCloseYoutubeModal = () => this.setState({ youtubeModal: false });

  render() {
    const { youtubeModal } = this.state;
    const { i18n, handleThemeSetupChangeScreen, themeRevert, storeExpired, tenantApp } = this.props;
    const enableAppVersionSwitching = checkUserEnableShowAppVersionSwitching(tenantApp);

    return (
      <Page
        title={i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.step0_Button'),
          disabled: storeExpired,
          onAction: () => handleThemeSetupChangeScreen(TypeScreen.Setup)
        }}>
        <TitleHelp
          i18n={i18n}
          hrefUserManual={
            enableAppVersionSwitching
              ? URL['Link_V2_Theme_ThemeSetup_ManualGuide_FormerVersion']
              : URL['Link_V2_Theme_ThemeSetup_ManualGuide']
          }
          hrefFAQ={URL['ThemeSetupV3Doc_FAQ']}
        />
        <Layout>
          <Layout.Section>
            <div className="show-hide-content-wraper">
              <div
                ref={this.ref}
                className="themesBox show-hide-content"
                style={{
                  marginTop: '20px',
                  marginBottom: '2.5rem',
                  opacity: 1
                }}>
                <Themes
                  handleRemoveThemeV3={this.props.handleRemoveThemeV3}
                  handleUpgrade={this.props.handleUpgrade}
                  themeRevert={themeRevert}
                  handleRemove={this.props.handleRemove}
                />
              </div>
            </div>
            <div className="theme-setup-menu">
              <div className="theme-setup-menu-action">
                <Button
                  disabled={storeExpired}
                  primary
                  onClick={() => handleThemeSetupChangeScreen(TypeScreen.Setup)}>
                  {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.step0_Button')}
                </Button>
              </div>
            </div>
          </Layout.Section>
        </Layout>
        <YoutubeModal
          active={youtubeModal}
          embeddedURL={URL['ThemeSetupTut']}
          title={i18n.translate('AdminHTML.ThemeSetup.ThemeSetup.youtubeModal_Title')}
          onClose={this.handleCloseYoutubeModal}
        />
      </Page>
    );
  }
}
const mapStateToProps = (state, props) => {
  const { oauth } = state;
  const tenantApp = _.get(oauth, 'tenantApp', {});
  return {
    tenantApp
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(ThemeSetupScreenList));
